<script>
import Entrance from '../Entrance'
export default {
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  render() {
    return (
      <div class="entranceGroup">
        {this.data.map((e) => {
          return <Entrance item={e} />
        })}
      </div>
    )
  },
}
</script>
<style lang="less" scoped>
.entranceGroup {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}
</style>
